export const featuredProjects = [
  {
    id: 1,
    title: "AI Waste Management System",
    subtitle: "Final Year Project 2024",
    description: "A comprehensive AI-powered Smart Waste Management System combining IoT hardware, computer vision, and web technologies for intelligent waste monitoring and classification.",
    longDescription: "This system automatically captures images of waste items, classifies them using machine learning, and provides real-time monitoring through a web dashboard. Features include ESP32-based smart bins, computer vision classification, and a Progressive Web App for monitoring.",
    category: "AI/IoT",
    type: "academic",
    companyProject: false,
    status: "completed",
    featured: true,
    technologies: [
      "Python", "FastAI", "ResNet-50", "ESP32", "React", "Flask",
      "Computer Vision", "IoT", "PWA", "Google Drive API", "ThingsBoard", "SQLite", "Redis",
      // Additional logical tags
      "Machine Learning", "AI", "Frontend", "Backend", "Database", "Cloud Storage", "Embedded Systems"
    ],
    features: [
      "AI-powered waste classification with 85%+ accuracy",
      "Real-time IoT sensor monitoring (ultrasonic, temperature, gas)",
      "Progressive Web App with offline capabilities",
      "Automated image capture and cloud storage",
      "Smart bin with servo-controlled lid and audio feedback",
      "Real-time dashboard with analytics and predictions"
    ],
    achievements: [
      "Integrated pre-trained ResNet-50 model for waste classification",
      "Built end-to-end IoT system with ESP32 and multiple sensors",
      "Developed PWA with service worker caching for offline use",
      "Implemented automated trigger system between hardware components",
      "Created scalable microservices architecture"
    ],
    images: ["/assets/img/portfolio/waste/waste1.png"],
    demoUrl: null,
    githubUrl: "https://github.com/Jayyy123/speer_notes",
    year: 2024
  },
  {
    id: 2,
    title: "AI Voice & Communication Systems",
    subtitle: "Enterprise Voice Solutions",
    description: "AI-driven calling and voice streaming solutions integrating advanced STT/TTS, LLMs, and telephony APIs for enterprise communication systems.",
    longDescription: "Comprehensive voice communication platform featuring voice cloning, speaker diarization, automated call recording, and intelligent voicemail detection for call center optimization.",
    category: "AI/Voice",
    type: "professional",
    companyProject: true,
    status: "completed",
    featured: true,
    technologies: [
      "Python", "Node.js", "Express.js", "Deepgram", "ElevenLabs", "OpenAI", "Claude",
      "Groq Llama", "Twilio", "Telnyx", "Voice Cloning", "STT/TTS", "MongoDB", "Redis", "WebSockets", "WebRTC",
      // Additional logical tags
      "AI", "LLM", "NLP", "Backend", "Database", "Real-time", "Communication", "Voice Technology", "API Integration"
    ],
    features: [
      "Advanced speech-to-text and text-to-speech processing",
      "Voice cloning and speaker diarization capabilities",
      "Automated voicemail detection and call recording",
      "Multi-language support and dynamic script management",
      "Real-time call analytics and summarization",
      "Integration with multiple telephony providers"
    ],
    achievements: [
      "Improved call center agent productivity by 40%",
      "Implemented real-time voice processing with <200ms latency",
      "Built scalable voice streaming architecture",
      "Integrated multiple AI models for enhanced accuracy",
      "Developed automated call quality monitoring"
    ],
    images: ["/assets/img/portfolio/voice/voice1.png"],
    demoUrl: null,
    githubUrl: null,
    year: 2024
  },
  {
    id: 3,
    title: "Workcity Backend API",
    subtitle: "RESTful API with JWT Authentication",
    description: "A comprehensive RESTful API built with Node.js, Express, and MongoDB for managing clients and projects with JWT-based authentication and role-based access control.",
    longDescription: "Full-featured backend API supporting client management, project lifecycle management, advanced filtering, pagination, and comprehensive security features. Includes automated testing with Jest and Supertest.",
    category: "Backend",
    type: "professional",
    companyProject: false,
    status: "completed", 
    featured: true,
    technologies: [
      "Node.js", "Express.js", "MongoDB", "Mongoose", "JWT", "bcryptjs",
      "Jest", "Supertest", "express-validator", "Helmet", "CORS",
      // Additional logical tags
      "Backend", "API", "Authentication", "Security", "Database", "Testing", "REST", "NoSQL"
    ],
    features: [
      "JWT-based authentication with role-based access control",
      "Complete CRUD operations for clients and projects",
      "Advanced filtering, search, and pagination",
      "Comprehensive input validation and security headers",
      "Automated testing suite with high coverage",
      "Statistics and analytics endpoints"
    ],
    achievements: [
      "Implemented secure authentication with password hashing",
      "Built comprehensive API with 15+ endpoints",
      "Achieved 90%+ test coverage with automated testing",
      "Implemented soft deletes and audit trails",
      "Added advanced query features (sorting, filtering, pagination)"
    ],
    images: ["/assets/img/portfolio/workcity/workcity1.png"],
    demoUrl: null,
    githubUrl: "https://github.com/Jayyy123/workcity-backend",
    additionalLinks: {
      frontend: "https://github.com/Jayyy123/workcity-frontend",
      wordpress: "https://github.com/Jayyy123/workcity-wordpress"
    },
    year: 2024
  },
  {
    id: 3,
    title: "AI Voice & Communication Systems",
    subtitle: "Enterprise Voice Solutions",
    description: "AI-driven calling and voice streaming solutions integrating advanced STT/TTS, LLMs, and telephony APIs for enterprise communication systems.",
    longDescription: "Comprehensive voice communication platform featuring voice cloning, speaker diarization, automated call recording, and intelligent voicemail detection for call center optimization.",
    category: "AI/Voice",
    type: "professional",
    status: "completed",
    featured: true,
    technologies: [
      "Python", "Node.js", "Deepgram", "ElevenLabs", "OpenAI", "Claude",
      "Groq Llama", "Twilio", "Telnyx", "Voice Cloning", "STT/TTS"
    ],
    features: [
      "Advanced speech-to-text and text-to-speech processing",
      "Voice cloning and speaker diarization capabilities",
      "Automated voicemail detection and call recording",
      "Multi-language support and dynamic script management",
      "Real-time call analytics and summarization",
      "Integration with multiple telephony providers"
    ],
    achievements: [
      "Improved call center agent productivity by 40%",
      "Implemented real-time voice processing with <200ms latency",
      "Built scalable voice streaming architecture",
      "Integrated multiple AI models for enhanced accuracy",
      "Developed automated call quality monitoring"
    ],
    images: [],
    demoUrl: null,
    githubUrl: null,
    year: 2023
  },
  {
    id: 4,
    title: "Backend-as-a-Service Platform",
    subtitle: "Developer Toolkit & Infrastructure",
    description: "Comprehensive BaaS platform with automated project scaffolding, AI-assisted code generation, and robust CI/CD processes for rapid application development.",
    longDescription: "Internal developer toolkit that automates project creation, generates code from Figma designs using AI, creates SDKs, and manages deployment pipelines with Jenkins and Docker.",
    category: "Platform",
    type: "professional",
    status: "completed",
    featured: true,
    technologies: [
      "Node.js", "Python", "Docker", "Jenkins", "AWS", "Figma API",
      "Anima", "Gemini AI", "SDK Generation", "CI/CD", "Infrastructure as Code", "PostgreSQL", "MySQL", "Redis",
      // Additional logical tags
      "Backend", "Cloud", "DevOps", "Database", "AI", "API", "Automation", "Microservices", "Containerization"
    ],
    features: [
      "Automated project scaffolding and boilerplate generation",
      "AI-assisted code generation from Figma designs",
      "Automated SDK creation and documentation",
      "Robust CI/CD pipelines with Jenkins integration",
      "Infrastructure provisioning and management",
      "Developer portal with project management tools"
    ],
    achievements: [
      "Reduced project setup time from days to minutes",
      "Automated 80% of repetitive development tasks",
      "Built scalable infrastructure supporting 100+ projects",
      "Implemented AI-powered code generation pipeline",
      "Created comprehensive developer documentation system"
    ],
    images: ["/assets/img/portfolio/baas/baas1.png"],
    demoUrl: null,
    githubUrl: null,
    year: 2023
  },
  {
    id: 5,
    title: "Courtmatchup Sports Platform",
    subtitle: "Sports Facility Booking System",
    description: "Comprehensive sports facility booking system with dynamic scheduling, calendar sync, Stripe Connect for multi-party payouts, and OpenAI-powered FAQ chatbot.",
    longDescription: "Built a complete sports facility booking platform featuring dynamic scheduling, calendar synchronization, Stripe Connect for multi-party payouts (clubs, coaches, staff), and an OpenAI-powered FAQ chatbot for enhanced user experience.",
    category: "Web Platform",
    type: "professional",
    status: "completed",
    featured: true,
    technologies: [
      "React", "Node.js", "Express.js", "MySQL", "Redis", "Stripe Connect", "OpenAI", "Google Calendar API",
      "Calendar Sync", "Multi-party Payments", "Chatbot Integration", "JWT", "OAuth",
      // Additional logical tags
      "Frontend", "Backend", "Database", "Payments", "AI", "LLM", "Authentication", "API Integration", "Scheduling"
    ],
    features: [
      "Dynamic scheduling with calendar integration",
      "Multi-party payment processing with Stripe Connect",
      "Automated facility availability management",
      "OpenAI-powered FAQ chatbot",
      "Real-time booking notifications",
      "Admin dashboard for facility management"
    ],
    achievements: [
      "Implemented complex multi-party payment system",
      "Integrated OpenAI chatbot for customer support",
      "Built scalable booking system handling multiple facilities",
      "Created automated calendar sync functionality",
      "Developed comprehensive admin management tools"
    ],
    images: ["/assets/img/portfolio/courtmatchup/court1.png"],
    demoUrl: null,
    githubUrl: null,
    year: 2023
  }
];

export const otherProjects = [
  {
    id: 6,
    title: "Rainmaker Platform",
    description: "Community management platform with referral tracking, meeting scheduling, and commission-based payment systems.",
    technologies: ["React", "Node.js", "Express.js", "MySQL", "Redis", "Stripe", "Google Calendar API", "Microsoft Graph API", "OAuth", "JWT"],
    category: "Web Platform",
    year: 2023
  },
  {
    id: 7,
    title: "Coinchord Platform",
    description: "Advanced platform with user profiles, cryptocurrency payments, and deep Hubspot CRM integration.",
    technologies: ["React", "Node.js", "Express.js", "MySQL", "Redis", "Stripe", "Authorize.net", "Eukapay", "Hubspot API", "JWT",
      // Additional logical tags
      "Frontend", "Backend", "Database", "Payments", "Cryptocurrency", "CRM", "Authentication", "API Integration", "Fintech"],
    category: "Fintech",
    year: 2023
  },
  {
    id: 8,
    title: "Auth8 Authentication Platform",
    description: "Authentication platform with expert/community voting, GraphQL, and third-party service integration.",
    technologies: ["React", "Node.js", "GraphQL", "MySQL", "Redis", "LegitApp API", "JWT", "OAuth"],
    category: "Authentication",
    year: 2023
  },
  {
    id: 9,
    title: "Invoice Automation System",
    description: "Automated invoice processing from email attachments with AI classification and TMS integration.",
    technologies: ["Python", "AI/ML", "Document Classification", "RegEx", "Gmail API", "IMAP", "SFTP", "Hubspot API", "TMS API", "MySQL", "Redis"],
    category: "Automation",
    year: 2023
  },
  {
    id: 10,
    title: "Digital Twin CRM",
    description: "Audio/video transcription system with vector databases and RAG-based chat interfaces.",
    technologies: ["Python", "Flask", "RAG", "Vector Databases", "Weaviate", "Pinecone", "OpenAI", "Claude", "Groq", "Transcription APIs", "React", "JavaScript", "MySQL", "Redis"],
    category: "AI/CRM",
    year: 2023
  },
  {
    id: 11,
    title: "AI Voice Cloning Studio",
    description: "Advanced voice cloning and synthesis platform using multiple TTS models and voice processing technologies.",
    technologies: ["Python", "TTS Models", "Voice Cloning", "ElevenLabs", "OpenVoice", "Audio Processing"],
    category: "AI/Voice",
    year: 2024
  },
  {
    id: 12,
    title: "LLM Fine-tuning Pipeline",
    description: "Comprehensive pipeline for fine-tuning various language models including DeepSeek, Llama, and Mistral models.",
    technologies: ["Python", "Transformers", "Fine-tuning", "DeepSeek", "Llama", "Mistral", "PyTorch"],
    category: "AI/NLP",
    year: 2024
  },
  {
    id: 13,
    title: "Computer Vision Research Lab",
    description: "Research platform for computer vision projects including background removal, image generation, and style transfer.",
    technologies: ["Python", "Computer Vision", "OpenCV", "TensorFlow", "PyTorch", "GANs"],
    category: "AI/Vision",
    year: 2024
  },
  {
    id: 14,
    title: "Speech Recognition Engine",
    description: "Advanced speech recognition system with real-time processing, noise reduction, and multi-language support.",
    technologies: ["Python", "Whisper", "Speech Recognition", "Noise Reduction", "Real-time Processing"],
    category: "AI/Audio",
    year: 2024
  },
  // Mobile Applications
  {
    id: 15,
    title: "Repairs App",
    subtitle: "Service Management Mobile App",
    description: "Flutter-based mobile application for managing repair services with real-time updates and Firebase backend.",
    category: "Mobile",
    type: "personal",
    status: "completed",
    technologies: ["Flutter", "Dart", "Firebase", "Cloud Firestore", "Firebase Auth", "Push Notifications",
      // Additional logical tags
      "Mobile", "Cross-platform", "Database", "Authentication", "Real-time", "Cloud", "NoSQL"],
    features: [
      "Service request management",
      "Real-time status updates",
      "User authentication",
      "Push notifications",
      "Cross-platform compatibility"
    ],
    year: 2022
  },
  {
    id: 16,
    title: "Universally Space App",
    subtitle: "Android Space Exploration App",
    description: "Native Android application for space exploration with MVVM architecture and external API integrations.",
    category: "Mobile",
    type: "personal",
    status: "completed",
    technologies: ["Kotlin", "Android SDK", "MVVM", "Retrofit", "OkHttp", "External APIs", "Room Database",
      // Additional logical tags
      "Mobile", "Android", "Architecture Pattern", "API Integration", "Database", "Local Storage", "Material Design"],
    features: [
      "Space data visualization",
      "MVVM architecture pattern",
      "RESTful API integration",
      "Local data caching",
      "Material Design UI"
    ],
    year: 2022
  },
  {
    id: 17,
    title: "Aberra Reminder App",
    subtitle: "Personal Reminder System",
    description: "Android reminder application with MVVM architecture for personal task management.",
    category: "Mobile",
    type: "personal",
    status: "completed",
    technologies: ["Kotlin", "Android SDK", "MVVM", "Room Database", "AlarmManager", "Notifications"],
    features: [
      "Task reminder system",
      "Local database storage",
      "Notification scheduling",
      "MVVM architecture",
      "Clean UI design"
    ],
    year: 2022
  },
  {
    id: 18,
    title: "Janim Notes App",
    subtitle: "Note-Taking Mobile Application",
    description: "Feature-rich note-taking app with local storage and network synchronization capabilities.",
    category: "Mobile",
    type: "personal",
    status: "completed",
    technologies: ["Kotlin", "Android SDK", "Room Database", "MVVM", "Retrofit", "OkHttp"],
    features: [
      "Rich text note editing",
      "Local data persistence",
      "Network synchronization",
      "Search functionality",
      "Export capabilities"
    ],
    year: 2022
  },
  {
    id: 19,
    title: "Jotit Todo App",
    subtitle: "Task Management Application",
    description: "Comprehensive todo application with local database and modern Android architecture.",
    category: "Mobile",
    type: "personal",
    status: "completed",
    technologies: ["Kotlin", "Android SDK", "Room Database", "MVVM", "LiveData", "Data Binding"],
    features: [
      "Task creation and management",
      "Priority levels and categories",
      "Local database storage",
      "Modern Android architecture",
      "Intuitive user interface"
    ],
    year: 2022
  },
  // Personal/Academic Projects
  {
    id: 20,
    title: "PSG Win/Lose Predictor",
    subtitle: "Football Match Prediction System",
    description: "Machine learning model to predict PSG football match outcomes using historical data and team statistics.",
    category: "AI/Sports",
    type: "personal",
    status: "completed",
    technologies: ["Python", "Django", "scikit-learn", "Pandas", "NumPy", "Machine Learning", "MySQL", "Redis"],
    features: [
      "Historical match data analysis",
      "Team performance metrics",
      "Prediction accuracy tracking",
      "Web-based interface",
      "Statistical visualizations"
    ],
    year: 2021
  },
  {
    id: 21,
    title: "AnimeJojo Website",
    subtitle: "Anime Streaming Platform",
    description: "Full-stack anime streaming website with user authentication, content management, and responsive design.",
    category: "Web Platform",
    type: "personal",
    status: "completed",
    technologies: ["Python", "Django", "Django REST Framework", "React", "HTML", "CSS", "JavaScript", "MySQL", "Redis"],
    features: [
      "User authentication system",
      "Video streaming capabilities",
      "Content management system",
      "Responsive web design",
      "RESTful API architecture"
    ],
    year: 2021
  },
  {
    id: 22,
    title: "Cinema Search Website",
    subtitle: "Movie Discovery Platform",
    description: "React-based movie search and discovery platform with external API integration for comprehensive movie data.",
    category: "Web App",
    type: "personal",
    status: "completed",
    technologies: ["React", "JavaScript", "External Movie APIs", "TMDB API", "CSS", "HTML"],
    features: [
      "Movie search functionality",
      "Detailed movie information",
      "Rating and review system",
      "Responsive design",
      "API data integration"
    ],
    year: 2021
  },
  {
    id: 23,
    title: "Heart Failure Predictor",
    subtitle: "Medical Prediction System",
    description: "Machine learning application for predicting heart failure risk using patient data and medical indicators.",
    category: "AI/Healthcare",
    type: "academic",
    status: "completed",
    technologies: ["Python", "Django", "scikit-learn", "Pandas", "NumPy", "Machine Learning", "MySQL", "Redis"],
    features: [
      "Patient data analysis",
      "Risk assessment algorithms",
      "Medical data visualization",
      "Prediction accuracy metrics",
      "Healthcare professional interface"
    ],
    year: 2021
  }
];

export const mlCollaborations = [
  {
    id: 15,
    title: "Voice Cloning & TTS Models",
    description: "Experiments with various TTS models including Parler TTS, OpenVoice, VoiceCraft, and Kokoro for voice synthesis.",
    technologies: ["Python", "TTS Models", "Voice Cloning", "Audio Processing"],
    category: "AI/Voice",
    notebooks: ["Parler tts Demo.ipynb", "OpenVoice_colab.ipynb", "VoiceCraft Inference TTS.ipynb", "Kokoro.ipynb"]
  },
  {
    id: 16,
    title: "LLM Fine-tuning & Training",
    description: "Fine-tuning experiments with various language models including DeepSeek, Llama, and Mistral models.",
    technologies: ["Python", "Transformers", "Fine-tuning", "LLMs"],
    category: "AI/NLP",
    notebooks: ["Ben_deepseek_3_8b_instruct_finetune.ipynb", "llama_3_8b_instruct_finetune.ipynb", "mistral-large-small-and-large.ipynb"]
  },
  {
    id: 17,
    title: "Computer Vision & Image Processing",
    description: "Various CV projects including background removal, image generation, and outfit manipulation.",
    technologies: ["Python", "Computer Vision", "Image Processing", "GANs"],
    category: "AI/Vision",
    notebooks: ["background_remover.ipynb", "ai_2024_photos.ipynb", "outfit-anyone.ipynb", "Flux.ipynb"]
  },
  {
    id: 18,
    title: "Audio & Speech Processing",
    description: "Speech recognition, audio manipulation, and subtitle generation projects.",
    technologies: ["Python", "Speech Recognition", "Audio Processing", "Whisper"],
    category: "AI/Audio",
    notebooks: ["fast_whisperer.ipynb", "WhisperStreaming.ipynb", "generateAndSyncSubtitles.ipynb", "silence_manipulation.ipynb"]
  },
  {
    id: 19,
    title: "Advanced AI Research Projects",
    description: "Collection of advanced AI research projects including AI Scientist, latent sync, and digital twin implementations.",
    technologies: ["Python", "AI Research", "Machine Learning", "Deep Learning"],
    category: "AI/Research",
    notebooks: ["Ai-Scientist.ipynb", "LatentSync_Colab.ipynb", "digital twin template.ipynb", "DigitalTwin.ipynb"]
  },
  {
    id: 20,
    title: "Data Scraping & Automation",
    description: "Advanced data scraping projects for social media platforms and automated data collection systems.",
    technologies: ["Python", "Web Scraping", "Data Collection", "Automation"],
    category: "Data Engineering",
    notebooks: ["meta_scrapper.ipynb", "vin_automation.ipynb", "josephs_waste_classifier.ipynb"]
  },
  {
    id: 21,
    title: "Generative AI & Image Models",
    description: "Experiments with generative AI models including Flux, Mid-Journey, and various image generation techniques.",
    technologies: ["Python", "Generative AI", "Image Generation", "AI Models"],
    category: "AI/Generative",
    notebooks: ["Flux.ipynb", "Mid-Journey.ipynb", "ai_2024_photos.ipynb"]
  },
  // Additional Collaboration Projects from collabs.md
  {
    id: 22,
    title: "Mobile AI Agents",
    description: "AI agent systems for mobile automation including Android and iOS intelligent automation.",
    technologies: ["Python", "Mobile AI", "Android Automation", "iOS Automation", "AI Agents"],
    category: "AI/Mobile",
    notebooks: ["android_agent.ipynb", "ios_agent.ipynb", "MKD Agent.ipynb"]
  },
  {
    id: 23,
    title: "Advanced TTS & Voice Synthesis",
    description: "Cutting-edge text-to-speech and voice synthesis research including custom TTS pipelines.",
    technologies: ["Python", "TTS", "Voice Synthesis", "Custom Models", "Audio ML", "Tacotron"],
    category: "AI/Voice",
    notebooks: ["custom-tts.ipynb", "custom_tts_pipeline.ipynb", "voice_model_generator.ipynb", "tortoise-tts-fast.ipynb", "tacotron_modelTraining.ipynb"]
  },
  {
    id: 24,
    title: "Video & Lip Sync Technology",
    description: "Advanced video synthesis and lip-sync technology for realistic talking head generation.",
    technologies: ["Python", "Video Synthesis", "Lip Sync", "Computer Vision", "Audio-Visual ML", "Wav2Lip"],
    category: "AI/Video",
    notebooks: ["Wav2Lip ENG.ipynb", "Wav2Lip-HQ pretraining.ipynb", "Wav2Lip_simplified_v5.ipynb", "wav-onyx.ipynb"]
  },
  {
    id: 25,
    title: "Language Classification & Translation",
    description: "Multi-language processing including language classification and translation systems.",
    technologies: ["Python", "NLP", "Language Classification", "Translation", "Multi-lingual AI", "VoxCeleb"],
    category: "AI/NLP",
    notebooks: ["voxceleb_langauge_classification.ipynb", "translator.ipynb", "paraphraser.ipynb"]
  },
  {
    id: 26,
    title: "Specialized AI Models",
    description: "Research on specialized AI models including decision trees, predictors, and domain-specific applications.",
    technologies: ["Python", "Machine Learning", "Specialized Models", "Domain AI", "Predictive Analytics", "Classification"],
    category: "AI/Specialized",
    notebooks: ["decision_tree.ipynb", "predictor.ipynb", "josephs_waste_classifier.ipynb", "Vin_automation.ipynb"]
  },
  {
    id: 27,
    title: "Advanced Audio Processing",
    description: "Sophisticated audio processing including voice model training and audio dataset creation.",
    technologies: ["Python", "Audio Processing", "Voice Models", "Dataset Creation", "Audio ML", "VoxCeleb"],
    category: "AI/Audio",
    notebooks: ["create_dataset_voxceleb2.ipynb", "create_dataset.ipynb", "train_model_1.ipynb", "train_model.ipynb", "voice.ipynb"]
  },
  {
    id: 28,
    title: "Multimodal AI Research",
    description: "Advanced multimodal AI research including latent synchronization and digital twin implementations.",
    technologies: ["Python", "Multimodal AI", "Latent Sync", "Digital Twin", "Advanced AI", "Research"],
    category: "AI/Research",
    notebooks: ["LatentSync_Colab.ipynb", "latentsync.ipynb", "digital twin template.ipynb", "DigitalTwin.ipynb", "boson.ipynb"]
  }
];

export const projectCategories = [
  { id: "all", name: "All Projects", count: 50 }, // Will be calculated dynamically in component
  { id: "featured", name: "Featured", count: featuredProjects.length },
  { id: "ai", name: "AI/ML", count: 35 }, // Including all AI/ML projects and collaborations
  { id: "web", name: "Web Apps", count: 8 }, // React, Django, web platforms
  { id: "mobile", name: "Mobile", count: 5 }, // Flutter and Android apps
  { id: "backend", name: "Backend", count: 12 }, // Node.js, Python, API projects
  { id: "research", name: "Research", count: mlCollaborations.length }
];
